<template>
  <div class="home">
    <div class="home__header">
      <div class="fl">
        <span>{{date}}</span>
        <!-- <span><i class="el-icon-map-location"></i>惠州市</span> -->
      </div>
      <div class="fr">
        <span>欢迎{{userInfo.userName}}</span>
        <span @click="goHome">控制台</span>
      </div>
    </div>
    <div class="home__content">
      <home-up />
      <home-down />
    </div>
  </div>
</template>
<script>
import homeDown from "./component/homeDown.vue";
import homeUp from "./component/homeUp.vue";
export default {
  components:{
    homeDown,
    homeUp
  },
  name:"home",
  data(){
    return{
      date:new Date().Format('yyyy-MM-dd')
    }
  },
  computed:{
    userInfo(){
      return this.$store.state.LOGINUSER
    }
  },
  methods:{
    //控制台按钮
    goHome(){
      this.$router.push({path:"/web"})
    },
  }
}
</script>
<style lang="scss" scoped>
.home{
  height: 100%;
  width: 100%;
  background: url("../../assets/images/home/bj.jpg");
  background-size: 100% 100%;
  &__header{
    width: 100%;
    background: url("../../assets/images/home/home_header.png");
    height: 80px;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    color:#A7C4E9;
    padding: 0 20px;
    box-sizing: border-box;
    align-items:flex-end;
    .fl{
      >span{
        display: inline-block;
        margin-right: 20px;
        >i{
          font-size: 20px;
          margin-right: 16px;
        }
      }
    }
    .fr{
      >span{
        display: inline-block;
        margin-left: 20px;
      }
      >span:last-child{
        background: #182060;
        width: 91px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        border: 1px solid #2a36a2;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }
  &__content{
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - 100px);
    padding: 20px;
    box-sizing: border-box;
    justify-content: left;
    >div{
      width: 100%;
    }
  }
  
}
</style>